/** @param {number} db */
export function dbToGain(db) {
    return Math.pow(10, db / 20);
}

/** @param {number} x @param {number} min @param {number} max */
export function clamp(x, min, max) {
    return Math.min(max, Math.max(min, x));
}

/** @param {number} x */
export function s3(x) {
    return x.toFixed(3);
}

/** @param {HTMLInputElement | null} input */
export function updateRangeFill(input) {
    if (!input) return;
    const min = Number.parseFloat(input.min ?? '0');
    const max = Number.parseFloat(input.max ?? '100');
    const val = Number.parseFloat(input.value ?? '0');
    if (!Number.isFinite(min) || !Number.isFinite(max) || max === min) return;
    const pct = ((val - min) / (max - min)) * 100;
    input.style.setProperty('--range-pct', `${clamp(pct, 0, 100)}%`);
}

/** @param {HTMLInputElement} input */
export function bindRangeFill(input) {
    updateRangeFill(input);
    input.addEventListener('input', () => updateRangeFill(input));
}
